import type { VirtualElement } from "../types/topNavTypes";

export const baseUrl = import.meta.env.SHICOM_BASE_URL;

export function makeLeftAnchor(
  anchorEl: HTMLElement | null,
): VirtualElement | null {
  if (!anchorEl) return null;

  const rect = anchorEl.getBoundingClientRect();
  const x = 0;
  const y = Math.round(rect.bottom) + 6;

  return {
    getBoundingClientRect: () => ({
      width: 0,
      height: 0,
      top: y,
      bottom: y,
      left: 0,
      right: 0,
      x,
      y,
      toJSON: () => {},
    }),
  };
}

export function safeTargetProps(target?: string) {
  if (!target) return {};
  const t = target.trim();
  if (!t) return {};
  if (t === "_blank") return { target: t, rel: "noopener noreferrer" };
  return { target: t };
}


